var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "bg-secondary-13 pl-4 pb-2 pr-4 pt-0 rounded" },
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-sm-12 col-md-6 col-lg-3 mt-2" },
          [
            _c("validation-provider", {
              attrs: { rules: "required" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function({ errors }) {
                    return [
                      _c("custom-drop-down", {
                        attrs: {
                          clearable: false,
                          "custom-error-msg":
                            _vm.validationMessages.practitionerType,
                          error: errors[0],
                          fieldkey: "id",
                          fieldname: "name",
                          label: "Tipo:",
                          options: _vm.practitionerTypes,
                          placeholder: "Seleccione"
                        },
                        model: {
                          value: _vm.value.practitionerType,
                          callback: function($$v) {
                            _vm.$set(_vm.value, "practitionerType", $$v)
                          },
                          expression: "value.practitionerType"
                        }
                      })
                    ]
                  }
                }
              ])
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-sm-12 col-md-6 col-lg-5 mt-4 mt-md-2 mt-sm-4" },
          [
            _c("validation-provider", {
              attrs: { rules: "required" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function({ errors }) {
                    return [
                      _c("custom-drop-down", {
                        attrs: {
                          clearable: false,
                          "custom-error-msg": _vm.validationMessages.college,
                          error: errors[0],
                          fieldkey: "id",
                          fieldname: "name",
                          label: "Universidad:",
                          options: _vm.universities,
                          placeholder: "Seleccione"
                        },
                        model: {
                          value: _vm.value.college,
                          callback: function($$v) {
                            _vm.$set(_vm.value, "college", $$v)
                          },
                          expression: "value.college"
                        }
                      })
                    ]
                  }
                }
              ])
            })
          ],
          1
        ),
        _vm.user.profile.companyid == undefined
          ? _c(
              "div",
              {
                staticClass: "col-sm-12 col-md-4 col-lg-4 mt-4 mt-md-2 mt-sm-4"
              },
              [
                _vm.user.profile.companyid == undefined
                  ? _c("validation-provider", {
                      attrs: { rules: "required" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function({ errors }) {
                              return [
                                _c("custom-drop-down", {
                                  attrs: {
                                    clearable: false,
                                    "custom-error-msg":
                                      _vm.validationMessages.company,
                                    disabled: _vm.editMode,
                                    error: errors[0],
                                    fieldkey: "id",
                                    fieldname: "name",
                                    label: "Compañía:",
                                    options: _vm.companies,
                                    placeholder: "Seleccione"
                                  },
                                  model: {
                                    value: _vm.value.company,
                                    callback: function($$v) {
                                      _vm.$set(_vm.value, "company", $$v)
                                    },
                                    expression: "value.company"
                                  }
                                })
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        3975952891
                      )
                    })
                  : _vm._e()
              ],
              1
            )
          : _vm._e(),
        _c(
          "div",
          {
            class:
              this.user.profile.companyid != undefined
                ? "col-sm-12 col-md-4 col-lg-4 mt-4 mt-md-2 mt-sm-4"
                : "col-sm-12 col-md-6 col-lg-3 mt-4 mt-md-2 mt-sm-4"
          },
          [
            _c("validation-provider", {
              attrs: { rules: "required" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function({ errors }) {
                    return [
                      _c("custom-drop-down", {
                        attrs: {
                          clearable: false,
                          "custom-error-msg":
                            _vm.validationMessages.specialtyType,
                          disabled:
                            _vm.value.practitionerType == null || _vm.editMode,
                          error: errors[0],
                          fieldkey: "id",
                          fieldname: "name",
                          label: "Especialidad:",
                          options: _vm.availableSpecialties,
                          placeholder: "Seleccione"
                        },
                        model: {
                          value: _vm.value.specialtyType,
                          callback: function($$v) {
                            _vm.$set(_vm.value, "specialtyType", $$v)
                          },
                          expression: "value.specialtyType"
                        }
                      })
                    ]
                  }
                }
              ])
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-sm-12 col-md-4 col-lg-2 mt-4 mt-md-2 mt-sm-4" },
          [
            _c("validation-provider", {
              attrs: { rules: "required" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function({ errors }) {
                    return [
                      _c("custom-date-picker", {
                        attrs: {
                          "class-container": "w-100",
                          "custom-error-msg": _vm.validationMessages.startDate,
                          error: errors[0],
                          label: "Fecha Desde:",
                          placeholder: "DD/MM/YYYY"
                        },
                        model: {
                          value: _vm.value.startDate,
                          callback: function($$v) {
                            _vm.$set(_vm.value, "startDate", $$v)
                          },
                          expression: "value.startDate"
                        }
                      })
                    ]
                  }
                }
              ])
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-sm-12 col-md-4 col-lg-2 mt-4 mt-md-2 mt-sm-4" },
          [
            _c("validation-provider", {
              attrs: { rules: "required" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function({ errors }) {
                    return [
                      _c("custom-date-picker", {
                        attrs: {
                          "class-container": "w-100",
                          "custom-error-msg": _vm.validationMessages.endDate,
                          error: errors[0],
                          label: "Fecha Hasta:",
                          placeholder: "DD/MM/YYYY"
                        },
                        model: {
                          value: _vm.value.endDate,
                          callback: function($$v) {
                            _vm.$set(_vm.value, "endDate", $$v)
                          },
                          expression: "value.endDate"
                        }
                      })
                    ]
                  }
                }
              ])
            })
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }